<template>
  <v-row class="ma-1">
    <v-col md="12" cols="12">
      <v-toolbar class="" color="primary" dark flat>
        <v-toolbar-title>Body</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          solo-inverted
          flat
          hide-details
          v-model="filter"
          prepend-inner-icon="mdi-magnify"
          clearable
        />
      </v-toolbar>
    </v-col>
    <v-col md="12" cols="12">
      <v-data-table
        :headers="headers"
        :items="body"
        :items-per-page.sync="tableItemsPerPage"
        sort-by="IDMB"
        :search="filter"
        class="elevation-1 clickableTable"
        @click:row="viewBod($event)"
        fixed-header
        ref="bodyTable"
        v-if="body.length > 0"
        :height="tableHeight"
      >
        <template v-slot:item.merania="{ item }">
          <template v-for="meranie in merania">
            <span
              :key="meranie"
              style="display: inline-block; width: 30px"
              v-if="getMeranieCountIconName(item, meranie) !== ''"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    {{ getMeranieCountIconName(item, meranie) }}
                  </v-icon>
                </template>
                <span>
                  {{ getMeranieCountText(item, meranie) }} -
                  {{ getMeranieCountPocet(item, meranie) }}
                </span>
              </v-tooltip>
            </span>
          </template>
        </template>
      </v-data-table>
      <v-overlay :value="loading">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-overlay>
    </v-col>
  </v-row>
</template>

<script>
import * as Enums from "../plugins/enums.js"

export default {
  data: () => ({
    loading: false,
    tableItemsPerPage: 10,
    merania: Enums.TYPY,
    headers: [
      {
        text: "ID monitorovaného bodu",
        align: "left",
        sortable: true,
        value: "BodID"
      },
      {
        text: "ID Lokality",
        align: "left",
        sortable: true,
        value: "LokalitaID"
      },
      {
        text: "Lokalita",
        align: "left",
        sortable: true,
        value: "LokalitaName"
      },
      { text: "Bod", align: "left", sortable: true, value: "ZNMB" },
      { text: "X", align: "right", sortable: true, value: "X" },
      { text: "Y", align: "right", sortable: true, value: "Y" },
      { text: "Z", align: "right", sortable: true, value: "Z" },
      { text: "Metódy", align: "right", sortable: false, value: "merania" }
    ],
    body: [],
    filter: ""
  }),

  components: {},

  computed: {
    tableHeight: function() {
      let ret = 800
      if (this.tableItemsPerPage !== -1) {
        ret = "auto"
      }
      return ret
    }
  },

  methods: {
    readBody: async function() {
      try {
        this.loading = true
        let response = await this.$axios.get("/r/body?lokalitaID=0")
        if (response.status === 200) {
          this.body = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      } finally {
        this.loading = false
      }
    },

    addBod: function() {
      this.$refs.dialogBod.show({ id: "" })
    },

    editBod: function(bod) {
      this.$refs.dialogBod.show(bod)
    },

    viewBod: function(bod) {
      this.$router.push({ name: "bod", params: { id: bod.ID } })
    },
    getMeranieCountIconName: function(bod, meranie) {
      let ret = this.getMeranieCountItem(bod, meranie)
      return ret.iconName
    },
    getMeranieCountText: function(bod, meranie) {
      let ret = this.getMeranieCountItem(bod, meranie)
      return ret.text
    },
    getMeranieCountPocet: function(bod, meranie) {
      let ret = this.getMeranieCountItem(bod, meranie)
      return ret.pocet
    },
    getMeranieCountItem: function(bod, meranie) {
      let ret = Enums.getMeranieCountItem(bod, meranie)
      ret.text = "Počet vykonaných meraní: " + ret.text
      return ret
    }
  },

  mounted: async function() {
    console.log("body mounted")
    await this.$store.dispatch("fetchme", this.$axios)
    await this.readBody()
  }
}
</script>
